import { AudioType } from './AudioType.ts';
import { AUDIO_FILES } from './audioFiles.ts';
export class AudioManager {
    static get isMuted() {
        if (this.masterGain == undefined) return true;
        return this.masterGain.gain.value === 0;
    }
    static async init(volume = this.DEFAULT_VOLUME) {
        this.pendingVolume = volume;
        this.unlockAudioWithFirstUserInteraction();
        await this.loadAll();
    }
    static async load(type, url) {
        var _this_buffers;
        if (((_this_buffers = this.buffers) === null || _this_buffers === void 0 ? void 0 : _this_buffers.has(type)) || this.rawBuffers.has(type)) return;
        const response = await fetch(url);
        if (!response.ok) {
            // eslint-disable-next-line no-console
            console.error(`Failed to load sound: ${url}`);
            return;
        }
        const arrayBuffer = await response.arrayBuffer();
        if (this.context == undefined || this.buffers == undefined) {
            this.rawBuffers.set(type, arrayBuffer);
            return;
        }
        const buffer = await this.context.decodeAudioData(arrayBuffer);
        this.buffers.set(type, buffer);
    }
    static async loadAll() {
        if (window['Cypress'] != undefined) return;
        const audioTypes = Object.values(AudioType).filter((value)=>typeof value === 'number');
        const promises = audioTypes.map((type)=>this.load(type, AUDIO_FILES[type]));
        await Promise.all(promises);
        this.handleAudioContextLossForIOSMobile();
    }
    static play(audio, relativeVolume = 1, pitch = 1) {
        if (this.buffers == undefined || this.context == undefined || this.masterGain == undefined) return;
        if (this.isMuted) return;
        const buffer = this.buffers.get(audio);
        if (!buffer) return;
        void this.resumeAudioContext();
        const source = this.context.createBufferSource();
        source.buffer = buffer;
        source.playbackRate.value = pitch;
        const gainNode = this.context.createGain();
        gainNode.gain.value = relativeVolume;
        gainNode.connect(this.masterGain);
        source.connect(gainNode);
        source.start(0);
    }
    static setMasterVolume(volume) {
        this.pendingVolume = volume;
        if (this.masterGain == undefined) {
            return;
        }
        this.masterGain.gain.value = volume;
    }
    static toggleMute() {
        const volume = this.isMuted ? this.DEFAULT_VOLUME : 0;
        this.setMasterVolume(volume);
    }
    static async resumeAudioContext() {
        if (this.context == undefined) {
            return;
        }
        if (this.context.state !== 'suspended') return;
        await this.context.resume();
    }
    static unlockAudioWithFirstUserInteraction() {
        const unlockAudio = async ()=>{
            if (this.isContextInitializationStarted) return;
            this.isContextInitializationStarted = true;
            this.context = new AudioContext();
            this.buffers = new Map();
            this.masterGain = this.context.createGain();
            this.masterGain.connect(this.context.destination);
            this.masterGain.gain.value = this.pendingVolume;
            for (const [type, arrayBuffer] of this.rawBuffers){
                const buffer = await this.context.decodeAudioData(arrayBuffer);
                this.buffers.set(type, buffer);
            }
            this.rawBuffers.clear();
            await this.resumeAudioContext();
        };
        document.addEventListener('click', unlockAudio, {
            once: true
        });
    }
    static handleAudioContextLossForIOSMobile() {
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') {
                setTimeout(async ()=>{
                    var _this_context;
                    await ((_this_context = this.context) === null || _this_context === void 0 ? void 0 : _this_context.resume());
                }, 500);
            }
        }, false);
    }
}
AudioManager.rawBuffers = new Map();
AudioManager.DEFAULT_VOLUME = 0.5;
AudioManager.pendingVolume = AudioManager.DEFAULT_VOLUME;
AudioManager.isContextInitializationStarted = false;
